import { render } from "./OrganizationTree.vue?vue&type=template&id=5bf0bf10"
import script from "./OrganizationTree.vue?vue&type=script&lang=js"
export * from "./OrganizationTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__